import React from "react";
import {Tooltip,} from "reactstrap";
import ButtonDesign from "../ButtonDesign";

const ButtonIconWithTooltip = (props) => {
    return (
        <span>
            <ButtonDesign
                btColor="light"
                btClass="bg-white mx-2 rounded-0 heartbtn btn-with-shadow btn-with-icon"
                onclickFunction={props.onClick}
                btId={props.id}>
                <img className="button-with-icon" src={props.icon}/>
            </ButtonDesign>
            {
                props.tooltip &&
                <Tooltip
                    placement="top"
                    isOpen={props.isOpen}
                    autohide={false}
                    target={props.id}
                    toggle={props.toggle}>
                    {props.tooltip}
                </Tooltip>
            }
        </span>
    )
};

export default ButtonIconWithTooltip;